module.exports = __webpack_public_path__ + "img/icon_investment.a6165784.svg";